// extracted by mini-css-extract-plugin
export default {"closeLink":"CloseableDialog_closeLink_3AUy5","dialog":"CloseableDialog_dialog_8KE4x"};